import { CertificateModel } from './certificate.model';

export class CertificateFactory {
  public static new(data?: Partial<CertificateModel>): CertificateModel {
    return new CertificateModel(data);
  }

  public static getModel(): any {
    return CertificateModel;
  }

  public static getPath(): string {
    return 'certificates';
  }
}
